<template>
    <div class="container-fluid bg-white container-fluid px-4 py-5 rounded-4 contenedor-principal">
        <h1>{{ $t("tramites.grid.titulo") }}</h1>
        <tramites-grid v-if="puedeVerTramitesInmobiliarios" />
        <tramites-energia-grid v-else />
    </div>
</template>

<script setup lang="ts">
import TramitesEnergiaGrid from "@/components/tramites/TramitesEnergiaGrid.vue";
import TramitesGrid from "@/components/tramites/TramitesGrid.vue";
import { useAuthorization } from "@/.shared/services/auth/authorization";
import { PermissionsApp } from "@/.shared/services/auth/authorization/authorization-service-impl";
import { computed } from "vue";

const autho = useAuthorization();

const puedeVerTramitesInmobiliarios = computed(() => {
    return autho.hasPermission(PermissionsApp.ViewSameCompanyTramites) || autho.hasPermission(PermissionsApp.ViewRelatedCompanyBranchTramites);
})

</script>